import { render, staticRenderFns } from "./SubPages.vue?vue&type=template&id=1c5b9a1a&"
import script from "./SubPages.vue?vue&type=script&lang=js&"
export * from "./SubPages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports